import { configDeviceList } from '../config/devicesList';

export const BACKEND_BREAKPOINT_TO_MEDIA = {
    desktop: '',
    laptop: '1535px',
    tabletLandscape: '1279px',
    tablet: '1023px',
    mobileLandscape: '767px',
    mobile: '639px',
};

export const getDevices = (editor) =>
    editor.Devices.getDevices().map((d) => ({
        id: d.get('id') || d.get('name'),
        name: d.get('name'),
        widthMedia: d.get('widthMedia') || '',
    }));

export const getDeviceWidthMediaById = (deviceId) => {
    const device = configDeviceList.devices.find((d) => d.id === deviceId);
    return device?.widthMedia || '';
};
